/**
 * Created by Ram on 4/10/2016.
 */

import React, { Component } from 'react';
import CustomerNav from './customer-nav';

export default class CustomerDashboard extends Component {
    render() {
        return (
            <div className="content-margin">
                <CustomerNav account={this.props.account} />
                { this.props.children }
            </div>
        )//return
    }//render
}//CustomersDashboard